import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BusinessInfoRoutingModule } from './business-info-routing.module';
import { BusinessInfoComponent } from './business-info.component';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { SharedModule } from 'src/app/shared';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { AddDocumentToProductComponent } from './add-document-to-product/add-document-to-product.component';

@NgModule({
  declarations: [
    BusinessInfoComponent,
    AddDocumentToProductComponent
  ],
  imports: [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  BusinessInfoRoutingModule,
  NgZorroAntdModule,
  SharedModule,
    NzTabsModule,
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
})
export class BusinessInfoModule { }
